<template>
   <div class="flex flex-wrap w-full pb-16">
        <div class="w-full md:w-1/5">
            <div class="w-full sm:w-[300px] min-h-[200px] px-2 border border-blue-300/40 flex flex-col justify-center items-center">
                <h2 class="text-5xl text-center">{{ player?.first_name }} {{ player?.last_name }}</h2>
                <h3 class="text-2xl">
                    <Link :href="route('mbbschedules', {conference: player?.team?.conference?.slug, team: player?.team?.short_name.toLowerCase()})">
                        <img :src="player.team?.logo" class="w-8 inline-block" aria-hidden="true"/>
                        {{ player?.team?.school }}
                    </Link>
                </h3>
                <p class="text-base">{{ player?.heightInInches }} | {{player.weight }}lbs | {{ player?.position }} </p>
            </div>
            <Players class="order-3" :players="player?.team?.players" />
            <!-- <table class="w-full">
                <tbody>
                    <tr v-for="p in team?.players" :class="{'active': $page.url==`/mbb/player/${p.id}`}" :key="p.id">
                        <td class="w-8 text-right pr-2">{{ p }}</td>
                        <td class="w-auto"><Link :href="`/mbb/player/${p.id}`">{{ p.first_name }} {{ p.last_name }}</Link></td>
                        <td>{{ $page.url }}</td>
                    </tr>
                </tbody>
            </table> -->
        </div>
        <div class="order-1 w-full md:w-4/5 pl-4  md:overflow-x-hidden overflow-x-scroll">
            <ul class="hidden flex flex-wrap ">
                <li>
                    <h1 class="text-2xl pl-1">{{ player?.first_name }}
                    {{ player?.last_name }}</h1>
                    <p class="pl-1 text-xl text-blue-200">
                    {{ player?.position}} |
                    {{ player?.team?.school}}
                    {{ player?.team?.name}} |
                    {{ player?.heightInInches }} |
                    {{ player?.weight }} lbs</p>
                </li>
            </ul>
            <ul class="summary flex flex-wrap w-full md:justify-start justify-between">
                <li>
                    <sup class="label">Points</sup>
                    {{ player.season_stats[0]?.careerpoints }}
                    <!-- {{ player }} -->
                </li>
                <li>
                    <sup class="label">FG Pct</sup>
                    {{ getTotalPercentage('fg_pct') }}%
                </li>
                <li>
                    <sup class="label">3pt Pct</sup>
                    {{ getTotalPercentage('fg3_pct') }}%
                </li>
                <li>
                    <sup class="label">FT Pct</sup>
                    {{ getTotalPercentage('ft_pct') }}%
                </li>
                <li>
                    <sup class="label">Assists</sup>
                    {{ getTotal('ast') }}
                </li>
                <li>
                    <sup class="label">Rebounds</sup>
                    {{ getTotal('reb') }}
                </li>
                <li>
                    <sup class="label">Steals</sup>
                    {{ getTotal('stl') }}
                </li>
                <li>
                    <sup class="label">TO Rate</sup>
                    {{ (getTotal('torate')/statsFiltered.length).toFixed(2) }}
                </li>
            </ul>
            <table class="w-full mb-16">
                <thead>
                    <tr class="border-b border-gray-500 text-blue-200">
                        <td :class="sorters('season')" @click="setSort('season')">Yr<Sorter :sortDir="sortDir" :sel="'season'" :sort="sort" /></td>
                        <td :class="sorters('season')" @click="setSort('team')">Tm<Sorter :sortDir="sortDir" :sel="'season'" :sort="sort" /></td>
                        <td :class="sorters('games_played')" @click="setSort('games_played')">GP<Sorter :sortDir="sortDir" :sel="'games_played'" :sort="sort" /></td>
                        <td :class="sorters('minutes')" @click="setSort('minutes')">Mins<Sorter :sortDir="sortDir" :sel="'minutes'" :sort="sort" /></td>
                        <!-- <td :class="sorters('minutes_per_game')" @click="setSort('minutes_per_game')">MPG<Sorter :sortDir="sortDir" :sel="'minutes_per_game'" :sort="sort" /></td> -->
                        <td :class="sorters('efficiency')" @click="setSort('efficiency')">Eff<Sorter :sortDir="sortDir" :sel="'efficiency'" :sort="sort" /></td>

                        <td :class="sorters('pts')" @click="setSort('pts')">Pts<Sorter :sortDir="sortDir" :sel="'pts'" :sort="sort" /></td>
                        <td :class="sorters('ppg')" @click="setSort('ppg')">PPG<Sorter :sortDir="sortDir" :sel="'ppg'" :sort="sort" /></td>
                        <td :class="sorters('fgm')" @click="setSort('fgm')">FGM<Sorter :sortDir="sortDir" :sel="'fgm'" :sort="sort" /></td>
                        <td :class="sorters('fga')" @click="setSort('fga')">FGA<Sorter :sortDir="sortDir" :sel="'fga'" :sort="sort" /></td>
                        <td :class="sorters('fg_pct')" @click="setSort('fg_pct')">FG %<Sorter :sortDir="sortDir" :sel="'fg_pct'" :sort="sort" /></td>
                        <td :class="sorters('fg3m')" @click="setSort('fg3m')">3PM<Sorter :sortDir="sortDir" :sel="'fg3m'" :sort="sort" /></td>
                        <td :class="sorters('fg3a')" @click="setSort('fg3a')">3PA<Sorter :sortDir="sortDir" :sel="'fg3a'" :sort="sort" /></td>
                        <td :class="sorters('fg3_pct')" @click="setSort('fg3_pct')">3P%<Sorter :sortDir="sortDir" :sel="'fg3_pct'" :sort="sort" /></td>
                        <td :class="sorters('ftm')" @click="setSort('ftm')">FTM<Sorter :sortDir="sortDir" :sel="'ftm'" :sort="sort" /></td>
                        <td :class="sorters('fta')" @click="setSort('fta')">FTA<Sorter :sortDir="sortDir" :sel="'fta'" :sort="sort" /></td>
                        <td :class="sorters('ft_pct')" @click="setSort('ft_pct')">FT%<Sorter :sortDir="sortDir" :sel="'ft_pct'" :sort="sort" /></td>
                        <td :class="sorters('ast')" @click="setSort('ast')">Asts<Sorter :sortDir="sortDir" :sel="'ast'" :sort="sort" /></td>
                        <td :class="sorters('apg')" @click="setSort('apg')">APG<Sorter :sortDir="sortDir" :sel="'apg'" :sort="sort" /></td>
                        <td :class="sorters('stl')" @click="setSort('stl')">Stls<Sorter :sortDir="sortDir" :sel="'stl'" :sort="sort" /></td>
                        <td :class="sorters('spg')" @click="setSort('spg')">SPG<Sorter :sortDir="sortDir" :sel="'stl'" :sort="sort" /></td>
                        <td :class="sorters('blk')" @click="setSort('blk')">Blks<Sorter :sortDir="sortDir" :sel="'blk'" :sort="sort" /></td>
                        <td :class="sorters('bpg')" @click="setSort('bpg')">BPG<Sorter :sortDir="sortDir" :sel="'bpg'" :sort="sort" /></td>
                        <td :class="sorters('reb')" @click="setSort('reb')">Reb<Sorter :sortDir="sortDir" :sel="'reb'" :sort="sort" /></td>
                        <td :class="sorters('rpg')" @click="setSort('rpg')">RPG<Sorter :sortDir="sortDir" :sel="'rpg'" :sort="sort" /></td>
                        <td :class="sorters('turnovers')" @click="setSort('turnovers')">TO<Sorter :sortDir="sortDir" :sel="'turnovers'" :sort="sort" /></td>
                        <td :class="sorters('torate')" @click="setSort('torate')">TORate<Sorter :sortDir="sortDir" :sel="'torate'" :sort="sort" /></td>
                        <!-- <td :class="sorters('PersonalFoulsPerGame')" @click="setSort('PersonalFoulsPerGame')">PF<Sorter :sortDir="sortDir" :sel="'PersonalFoulsPerGame'" :sort="sort" /></td> -->
                    </tr>
                </thead>
                <tbody>
                    <tr class="group" v-for="s in player?.season_stats" :key="s.player_id">
                        <td :class="['stat-field', {'high-class': isHighest(s, 'season')}]">{{ s.season }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'season')}]">{{ player.team.short_name }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'games_played')}]">{{ s.games_played }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'minutes')}]">{{ s.minutes ?? 0 }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'efficiency')}]">{{ s.efficiency }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'pts')}]">{{ s.pts }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'ppg')}]">{{ s.ppg }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'fgm')}]">{{ s.fgm }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'fga')}]">{{ s.fga }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'fg_pct')}]">{{ s.fg_pct }}%</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'fg3m')}]">{{ s.fg3m }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'fg3a')}]">{{ s.fg3a }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'fg3_pct')}]">{{ s.fg3_pct }}%</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'ftm')}]">{{ s.ftm }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'fta')}]">{{ s.fta }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'ft_pct')}]">{{ s.ft_pct}}%</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'ast')}]">{{ s.ast }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'apg')}]">{{ s.apg }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'stl')}]">{{ s.stl }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'spg')}]">{{ s.spg }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'blk')}]">{{ s.blk }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'bpg')}]">{{ s.bpg }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'reb')}]">{{ s.reb }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'rpg')}]">{{ s.rpg }}</td>
                        <td :class="['stat-field', {'high-class': isHighest(s, 'turnovers')}]">{{ s.turnovers }}</td>
                        <td :class="['stat-field', {'high-class': isLowest(s, 'torate')}]">{{ s.torate }}</td>
                    </tr>

                </tbody>
                <tfoot>
                    <tr>
                        <td class="text-right pr-1">Totals</td>
                        <td>&nbsp;</td>
                        <td class="text-right pr-1">{{ getTotal('games_played') }} </td>
                        <td class="text-right pr-1">{{ (getTotal('minutes')/statsFiltered.length).toFixed(2) }}</td>
                        <td class="text-right pr-1">{{ (getTotal('efficiency')/statsFiltered.length).toFixed(2) }}</td>
                        <td class="text-right pr-1">{{ getTotal('pts') }}</td>
                        <td class="text-right pr-1">
                            {{ getTotalOverGamesPlayed('pts') }}
                            <!-- {{ (getTotal('pts')/getTotal('games_played')).toFixed(1)}} -->
                        </td>
                        <td class="text-right pr-1">{{ getTotal('fgm') }}</td>
                        <td class="text-right pr-1">{{ getTotal('fga') }}</td>
                        <td class="text-right pr-1">
                            {{ getTotalOverSeasonsPlayed('fg_pct', 2) }}
                            <!-- {{ (getTotal('fg_pct')/statsFiltered.length).toFixed(2) }}% -->
                        </td>
                        <td class="text-right pr-1">{{ getTotal('fg3m') }}</td>
                        <td class="text-right pr-1">{{ getTotal('fg3a') }}</td>
                        <td class="text-right pr-1">{{ getTotalOverSeasonsPlayed('fg3_pct', 2) }}</td>

                        <td class="text-right pr-1">{{ getTotal('ftm') }}</td>
                        <td class="text-right pr-1">{{ getTotal('fta') }}</td>
                        <td class="text-right pr-1">{{ getTotalOverSeasonsPlayed('ft_pct', 2) }}</td>
                        <td class="text-right pr-1">{{ getTotal('ast') }}</td>
                        <td class="text-right pr-1">{{ getTotal('apg').toFixed(2) }}</td>
                        <td class="text-right pr-1">{{ getTotal('stl') }}</td>
                        <td class="text-right pr-1">{{ getTotal('spg').toFixed(2) }}</td>
                        <td class="text-right pr-1">{{ getTotal('blk') }}</td>
                        <td class="text-right pr-1">{{ getTotal('bpg').toFixed(2) }}</td>
                        <td class="text-right pr-1">{{ getTotal('reb') }}</td>
                        <td class="text-right pr-1">{{ getTotal('rpg').toFixed(2) }}</td>
                        <td class="text-right pr-1">{{ getTotal('turnovers') }}</td>
                        <td class="text-right pr-1">{{ getTotalOverSeasonsPlayed('torate', 2) }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
   </div>
</template>

<script>
import GuestLayout from '@/Layouts/GuestLayout.vue';
import Sorter from '@/Components/Sorter.vue'
import { Link } from '@inertiajs/vue3';
import BasketballPlayers from '@/Components/BasketballPlayers.vue';

export default {
   name: "MBBPlayer",
   layout: GuestLayout,
   components: { Link, Sorter, Players: BasketballPlayers },
   props: ['player', 'team'],
   computed: {
    statsFiltered() {
        return this.player?.season_stats;
    }
   },
   data() {
       return {
            sort: null,
            sortDir: 'desc',
            oldSort: null,
       }
   },
   mounted() {

   },
   methods: {
        sorters(sel) {
            if(this.sort === sel) {
                return 'text-right text-yellow-300 cursor-pointer'
            }else{
                return 'text-right cursor-pointer'
            }
        },
        isLowest(t, field) {
            let low=Math.min(...this.statsFiltered?.map(o => o[field]));
            return low === parseFloat(t[field]) ? true : false;
        },
        isHighest(t, field) {
            let high=Math.max(...this.statsFiltered?.map(o => o[field]));
            return parseFloat(high) === parseFloat(t[field]) ? true : false;
        },
        setSort(n) {
            this.sort=n;
            this.sortDir=this.sortDir==='asc' || this.sort !== this.oldSort ? 'desc' : 'asc';

            this.sortStats();
            this.oldSort=n;
        },
        getTotal(field) {
            return this.statsFiltered.reduce((acc, stat) => acc + parseFloat(stat[field]), 0);
        },
        getTotalPercentage(field) {
            const total=this.statsFiltered.reduce((acc, stat) => acc + parseFloat(stat[field]), 0);
            // return total/this.statsFiltered.length;
            return (total/this.statsFiltered.length).toFixed(2);
        },
        getTotalOverGamesPlayed(field, places=2) {

            if(this.getTotal(field) == 0 || this.getTotal('games_played') ==0) return 0;

            return (this.getTotal(field)/this.getTotal('games_played')).toFixed(places);
        },
        getTotalOverSeasonsPlayed(field, places=2) {
            if(this.getTotal(field) == 0 || this.statsFiltered.length < 1) return 0;
            return (this.getTotal(field)/this.statsFiltered.length).toFixed(places)+"%";
        }
   }
}
</script>
<style lang="css">
.selsort::after {
    content: '#8595;'
}

tbody tr:nth-child(even) {
    @apply bg-slate-400/50;
}
tbody tr {
    @apply hover:bg-slate-950 hover:text-white hover:cursor-pointer transition-all duration-200 mb-2;
}
tbody tr td {
    @apply py-1;
}
tbody tr td.stat-field {
    @apply text-right px-1 text-lg;
}

.high-class {
    @apply text-yellow-400 font-bold group-hover:text-yellow-600  transition-all duration-200;
}
</style>
<style>
.summary {
    @apply pl-0 p-2 pt-0 w-full;
}
.summary li {
    @apply border border-slate-300/20 mx-1;
    position: relative;
    font-size: 1.5em;
    width: 110px;
    padding: 16px 4px 4px 8px;
    text-align:left;
}
.summary sup {
    position: absolute;
    font-size: .7em;
    top: 0;
    left: 0;
    padding: 12px 4px 0 8px;
    color: hsl(190, 50%, 80%);
}
tfoot tr td {
    @apply bg-slate-950;
}
tbody tr.active td {
    @apply bg-yellow-500 text-black font-bold no-underline hover:border-none border-none ;
}
</style>
